import { message } from "antd";
import intl from "react-intl-universal";
const copyBatch = (batch) => {
  const aux = document.createElement("input");
  aux.setAttribute("value", batch);
  document.body.appendChild(aux);
  aux.select();
  document.execCommand("copy");
  aux.className = "aux";
  aux.style.display = "none";
  document.body.removeChild(aux);
  message.success(intl.get("copy_text"));
};

export default copyBatch;
